<template>
  <div>
    <div style="width: 1300px; margin: auto">
      <div class="twoPie">
        <div class="genome">
          <div class="intro">
            <svg
              t="1705486465949"
              class="icon"
              viewBox="0 0 1027 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3908"
              width="50"
              height="50"
            >
              <path
                d="M126.130201 900.941555a5.983099 5.983099 0 0 1-4.20434-10.187439l293.737832-293.818686a5.983099 5.983099 0 1 1 8.085269 8.08527l-293.414421 294.142096a5.983099 5.983099 0 0 1-4.20434 1.778759zM82.712305 849.43839a5.983099 5.983099 0 0 1-4.20434-10.18744l338.853635-338.934488a5.983099 5.983099 0 0 1 8.085269 8.08527l-338.530224 339.257898a5.983099 5.983099 0 0 1-4.20434 1.77876zM47.379678 789.849955a5.983099 5.983099 0 0 1-4.20434-10.187439L416.957336 405.880517a5.983099 5.983099 0 0 1 8.08527 8.08527L51.664871 788.152049a5.983099 5.983099 0 0 1-4.285193 1.697906zM21.345111 721.044314a5.983099 5.983099 0 0 1-4.20434-10.18744l393.429203-393.429202a5.983099 5.983099 0 0 1 8.085269 8.085269L25.549451 719.588965a5.983099 5.983099 0 0 1-4.20434 1.455349zM11.642788 635.825575a5.983099 5.983099 0 0 1-4.20434-10.187439l404.263463-404.263463a5.983099 5.983099 0 1 1 8.08527 8.085269l-404.263464 404.263463a5.983099 5.983099 0 0 1-3.880929 2.10217zM11.40023 541.227925a5.983099 5.983099 0 0 1-4.20434-10.187439L344.10906 194.046463a5.983099 5.983099 0 0 1 8.085269 8.085269L15.60457 539.449166a5.983099 5.983099 0 0 1-4.20434 1.778759z"
                fill="#8a8a8a"
                p-id="3909"
              ></path>
              <path
                d="M421.161676 1023.999353a421.161676 421.161676 0 1 1 0-842.323352h0.404264a5.983099 5.983099 0 0 1 5.983099 5.983099v409.195478h408.791214a5.983099 5.983099 0 0 1 5.9831 5.983099 420.434002 420.434002 0 0 1-421.161677 421.161676zM415.663693 194.046463a409.438036 409.438036 0 1 0 414.693461 414.774313H421.646792a5.983099 5.983099 0 0 1-5.983099-5.983099z"
                fill="#8a8a8a"
                p-id="3910"
              ></path>
              <path
                d="M600.81636 24.255808v399.008038h398.522922A398.846333 398.846333 0 0 0 600.81636 24.255808z"
                fill="#8a8a8a"
                p-id="3911"
              ></path>
              <path
                d="M1020.280129 498.618556H537.266143a7.5193 7.5193 0 0 1-7.5193-7.5193V7.5193a7.5193 7.5193 0 0 1 7.5193-7.5193 490.614139 490.614139 0 0 1 490.533287 491.018403 7.5193 7.5193 0 0 1-7.519301 7.600153z m-475.413833-15.119454h467.81368A475.494686 475.494686 0 0 0 544.866296 15.200306z"
                fill="#8a8a8a"
                p-id="3912"
              ></path>
            </svg>
            <span class="title">Genomic statistics</span>
          </div>
          <div class="info_container">
            <div class="summary">
              <div v-for="(item, index) in data" :key="index">
                <span class="title2" :style="item.style"
                  >{{ item.name }} ({{ item.value }})</span
                >
              </div>
            </div>
            <div class="graph"><GenomesPie /></div>
          </div>
        </div>
        <div class="gene">
          <div class="intro">
            <svg
              t="1705486599846"
              class="icon"
              viewBox="0 0 1047 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4161"
              width="50"
              height="50"
            >
              <path
                d="M489.686326 127.118884v404.36093h426.269767v29.767442c0 242.021209-196.560372 438.533953-440.486698 442.772837l-9.597023 0.047628-6.429767-0.142884a450.393302 450.393302 0 0 1-275.051163-99.185116l-8.215814-6.739349 38.364279-45.532279a390.525023 390.525023 0 0 0 236.020093 91.636093l16.860279 0.452465c202.275721 0 368.378047-152.099721 387.214884-346.397767l0.595349-7.144186h-425.07907V127.118884h59.534884z"
                fill="#bfbfbf"
                p-id="4162"
              ></path>
              <path
                d="M371.878698 128.642977l12.478511 58.225116C206.919442 224.851349 78.395535 380.189767 78.395535 561.247256c0 75.204465 22.027907 147.027349 62.464 208.372093l4.738977 7.025116 301.175069-248.022325 37.864186 45.96093L136.31107 861.445953l-18.884465-23.242418a437.414698 437.414698 0 0 1-98.589768-276.956279c0-206.538419 144.384-383.857116 344.659349-430.722977l8.382512-1.881302z"
                fill="#bfbfbf"
                p-id="4163"
              ></path>
              <path
                d="M457.394605 293.816558v59.534884H123.475349v-59.534884zM454.608372 445.701953v59.534884H62.58307v-59.534884zM371.497674 597.563535v59.534884H55.557953v-59.534884zM589.395349 17.860465v440.55814h440.558139V428.651163C1029.953488 200.918326 847.705302 17.860465 619.162791 17.860465h-29.767442z m59.534884 381.023256V78.60986l0.381023 0.023814a349.231628 349.231628 0 0 1 319.106977 312.105675l0.762046 8.144372H648.930233z"
                fill="#bfbfbf"
                p-id="4164"
              ></path>
            </svg>
            <span class="title">Gene statistics</span>
          </div>
          <div class="graph"><GenesPie /></div>
        </div>
      </div>

      <div class="scatter">
        <div class="intro">
          <svg t="1731661398084" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4472" width="50" height="50"><path d="M85.333333 0v938.666667h938.666667v85.333333H0V0h85.333333z m789.333334 725.333333a64 64 0 1 1 0 128 64 64 0 0 1 0-128z m-469.333334-85.333333a64 64 0 1 1 0 128 64 64 0 0 1 0-128z m-170.666666-170.666667a64 64 0 1 1 0 128 64 64 0 0 1 0-128z m341.333333-85.333333a64 64 0 1 1 0 128 64 64 0 0 1 0-128z m-213.333333-85.333333a64 64 0 1 1 0 128 64 64 0 0 1 0-128z m469.333333-128a64 64 0 1 1 0 128 64 64 0 0 1 0-128z m-597.333333-85.333334a64 64 0 1 1 0 128 64 64 0 0 1 0-128z m298.666666 0a64 64 0 1 1 0 128 64 64 0 0 1 0-128z" p-id="4473" fill="#bfbfbf"></path></svg>
          <span class="title">Genomic statistics</span>
        </div>
        <div style="display: flex; justify-content: center; width: 100%;">
          <Scatter />
        </div>
      </div>
    </div>
    </div>
</template>

<script>
import GenomesPie from "../components/GenomesPie.vue";
import GenesPie from "../components/GenesPie.vue";
import Scatter from "../components/Scatter.vue";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Statistics",
  components: { GenomesPie, GenesPie, Scatter },
  data() {
    return {
      data: [],
      styles: [
        { color: "rgb(23, 69, 143)" },
        { color: "rgb(42, 163, 127)" },
        { color: "rgb(181, 181, 47)" },
        { color: "rgb(193, 88, 65)" },
        { color: "rgb(85, 172, 199)" },
      ],
    };
  },
  methods: {
    async initChart() {
      this.data = [];
      await this.$axios.get("/api/api.echarts/pieChart/genomes").then((res) => {
        res.data.data.forEach((element) => {
          if (element.name != null) {
            if(element.name == "Phycophyta"){
              // 元素后期维护存在一定困难，学名错误
              element.name = "Algae";
              element.style = this.styles[this.data.length];
            }else{
              element.style = this.styles[this.data.length];
            }
            if (element.name == "Angiosperm") {
              element.name = "Angiosperms";
              element.style = this.styles[this.data.length];
            } else {
              element.style = this.styles[this.data.length];
            }
            if (element.name == "Gymnosperm") {
              element.name = "Gymnosperms";
              element.style = this.styles[this.data.length];
            } else {
              element.style = this.styles[this.data.length];
            }
            if (element.name == "Bryophyte") {
              element.name = "Bryophytes";
              element.style = this.styles[this.data.length];
            } else {
              element.style = this.styles[this.data.length];
            }
            if (element.name == "Pteridophyte") {
              element.name = "Pteridophytes";
              element.style = this.styles[this.data.length];
            } else {
              element.style = this.styles[this.data.length];
            }
            this.data.push(element);
          }
        });
      });
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
};
</script>

<style scoped>
.intro {
  display: flex;
  flex-wrap: wrap;
}
.title {
  font-size: 23px;
  font-weight: 700;
  color: #696565;
  margin: 10px 200px 20px 20px;
}
.title2 {
  font-size: 15px;
  font-weight: 600;
  margin: 10px 10px;
}
.info_container {
  display: flex;
}
.graph {
  width: 500px;
}
.twoPie {
  display: flex;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  border-radius: 16px;
  padding: 20px;
  margin-top: 25px;
  margin-bottom: 25px;
  box-sizing: border-box;
  background-color: #fff;
}
.scatter {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 25px;
  box-sizing: border-box;
  background-color: #fff;
}
</style>